import React from "react";
import "./videomodal.css";

const VideoModal = ({ show, handleClose, videoUrl }) => {
  if (!show) return null;

  return (
    <div className="video-modal-overlay" onClick={handleClose}>
      <div className="video-modal-content">
        <button className="video-modal-close" onClick={handleClose}>
          &times;
        </button>

        <div className="video-wrapper">
          <iframe
            src={`${videoUrl}&autoplay=1&mute=1`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="video-iframe"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
